/**
 * Australian Instance Configuration
 * Controls features for the Australian server/database instance
 */

export default {
  code: 'AU',
  name: 'Australia',
  app_url: 'https://www.takso-outcomes.com',
  // Feature flags
  // TAK-2088: Culture Counts is no longer offered — hides its links and
  // wording; plans and responses already collected through it are kept
  withCultureCounts: false,
  // Language settings
  dfltLanguage: import.meta.env.REACT_APP_I18N_DFLT_LANG || 'en',
  fixedLanguage:
    typeof import.meta.env.REACT_APP_I18N_FIXED_LANG === 'undefined'
      ? true
      : ['true', '1'].includes(
          import.meta.env.REACT_APP_I18N_FIXED_LANG.toLowerCase()
        ),
  // Instance settings
  contactEmail: 'support@takso-outcomes.com',
  contactEmail2: 'support@takso-app.com',
  defaultCountryCode: 'AU',
  defaultCurrencyTypeId: 1, // AUD {australian dollar}
  // TODO:i18n above should be enough - but would need to load currencies from db etc etc
  defaultCurrencyCode: 'AUD',
  // Validation rules
  validation: {
    phoneRegex:
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
    phoneFormat: '0X XXXX XXXX',
    phoneMinLength: 10,
    phoneMaxLength: 10,
  },
};
